<template>
    <div>
        <b-row class="mb-4">
            <b-col sm="10">
              <b-row>
                <b-col sm="4" cols="12" class="mt-sm-0 mt-3">
                  <b-form-input name="nombre"
                                type="text"
                                placeholder="Buscar..."
                                v-model="users.busqueda"
                                @keypress.enter="buscador(users.busqueda)"
                  />
                </b-col>
                <b-col sm="2" cols="12" class="mt-sm-0 mt-3">
                  <el-select
                      class="user-actives"
                      v-model="users.activo"
                      filterable
                      clearable
                      placeholder="Activos / Inactivos"
                      remote
                  >
                    <el-option label="Activos" :value="1"/>
                    <el-option label="Inactivos" :value="0"/>
                  </el-select>
                </b-col>
                <b-col cols="6" class="mt-sm-0 mt-3">
                    <b-button variant="primary"
                              class="mx-1"
                              @click.prevent="buscador(users.busqueda)">
                      <i class="fa fa-search fa-lg"/>
                      <span class="d-none d-md-inline-block">Buscar</span>
                    </b-button>
                    <b-button @click="limpiar()"  class="mx-1">
                      <i class="fa fa-eraser fa-lg"/>
                      <span class="d-none d-md-inline-block"> Limpiar</span>
                    </b-button>
                </b-col>
              </b-row>
            </b-col>

            <b-col sm="2" v-if="validarPermisoComponente('empresa-editar-usuarios')">
                <b-button variant="primary"
                          class="float-right"
                          @click="_mostrarModalUsuario"
                >
                    Nuevo
                </b-button>

                <b-dropdown id="dropdown"
                            text="Opciones"
                            class="float-right mx-1"
                            variant="info"
                >
                    <b-dropdown-item @click="getUsuariosDescargable">
                        <i class="fa fa-download"/>Exportar usuarios
                    </b-dropdown-item>
                    <b-dropdown-item @click="mostrarImportesAgendados(true)">
                        <i class="fa fa-list"/>
                        Consultar importes procesados
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>


        <b-table responsive
                 class="b-table-users-m"
                 :small="widthWindow <= 1558 ? true : false"
                 striped
                 hover
                 :items="listadoUsuario.data"
                 :fields="columnas"
                 empty-text="No hay usuarios para mostrar"
                 show-empty
                 thead-tr-class="table-active"
        >
            <!-- Rol -->
            <template v-slot:cell(rol)="data">
                <div v-if="data.item.roles && data.item.roles[0]">
                    <span
                        v-for="rol in data.item.roles"
                        :key="rol.id"
                    >
                    {{ rol.rol }}<br>
                    </span>
                </div>
                <div v-else>
                    No registra
                </div>
            </template>

            <template v-if="validarPermisoComponente('empresa-editar-usuarios')" v-slot:cell(actions)="data">
                <el-tooltip content="Editar Usuario"
                            placement="top"
                            effect="light"
                >
                    <i class="fa fa-edit fa-lg"
                       @click="getUsuarioDetalle(data.item.id)"
                    ></i>
                </el-tooltip>
            </template>

            <!-- Estado -->
            <template v-slot:cell(activo)="data">
                <b-badge v-if="data.item.activo"
                         variant="primary"
                         v-text="'Activo'"
                />
                <b-badge v-else
                         variant="danger"
                         v-text="'Inactivo'"
                />
            </template>
        </b-table>
        <b-row>
            <b-col>
                <b-button @click="backRoute()"
                          size="sm"
                          variant="secondary"
                          class="float-left"
                >
                    <i class="fa fa-reply fa-lg"></i>
                    Volver
                </b-button>

                <!-- Paginación -->
                <el-pagination v-if="listadoUsuario.data && !!listadoUsuario.data.length"
                               v-model="users.page"
                               @size-change="buscador(users.busqueda)"
                               @current-change="buscador(users.busqueda)"
                               :current-page.sync="users.page"
                               class="float-right"
                               :page-size.sync="users.perPage"
                               :page-sizes="[10, 15, 30, 50, 100]"
                               layout="total, sizes, prev, pager, next"
                               :total="listadoUsuario.total"
                />
            </b-col>
        </b-row>
        <usuario-formulario @importes="mostrarImportesAgendados(true)"/>
        <b-modal class="modalImportes"
                 hide-footer
                 v-model="modalImportes"
                 size="xl"
                 :title="'Importes agendados'"
        >
            <UsuariosMasivoAgendados :importes="importesAgendados"></UsuariosMasivoAgendados>
        </b-modal>
    </div>
</template>

<script>

import UsuarioFormulario from './formulario';
import UsuariosMasivoAgendados from '../UsuariosMasivoAgendados';
import {mapState, mapActions, mapMutations} from 'vuex';
import {obtenerLicenciaActiva} from '../../../servicios/empresa/actions';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: 'empresa-usuarios',
    data() {
        return {
            modalImportes: false,
            widthWindow: window.innerWidth,
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    components: {
        UsuariosMasivoAgendados,
        UsuarioFormulario
    },
    computed: {
        ...mapState('empresa', [
            'listadoUsuario',
            'selectedUsuario',
            'edicionUsuario',
            'rolesSeleccionados',
            'users',
            'errorUsu',
            'selectedExcelUsuarios',
            'selectedEmpresa',
            'importesAgendados',
            'licencia',
            'licencia_activa'
        ]),
        usuariosActivos() {
            return this.listadoUsuario.data.filter(u => u.activo).length;
        },
        columnas() {
            const columnasBase = [
                {key: 'cedula', label: 'Cédula', sortable: true},
                {key: 'name', label: 'Nombre', sortable: true},
                {key: 'email', label: 'Email', sortable: true},
                {key: 'telefono', label: 'Teléfono', sortable: true},
                {key: 'rol', label: 'Rol', sortable: false},
                {key: 'created_at', label: 'Creado', sortable: true},
                {key: 'activo', label: 'Estado', tdClass: 'text-center'},
            ];

            if (this.validarPermisoComponente('empresa-editar-usuarios')) {
                columnasBase.push({key: 'actions', label: 'Ver', tdClass: 'text-center', sortable: true});
            }

            return columnasBase;
        },
    },
    async mounted() {
        this.setEmpUs(this.$route.params.id);
        await this.getRoles();
        await this.getUsuarios();
        await this.fetchProviders();
        await this.getPermisosFiltro();
        await this.obtenerLicenciaActiva();
        window.addEventListener('resize', this.updateWindowSize);
    },
    methods: {
      updateWindowSize() {
        this.widthWindow = window.innerWidth;
      },
        async mostrarImportesAgendados(boolean) {
            await this.listarImportesAgendados(this.selectedEmpresa.id);
            if (boolean) {
                this.modalImportes = true;
            }
        },
        _mostrarModalUsuario() {
            this.resetSelectedUsuario();
            this.establecerAccionUsuario('Crear');
            this.establecerModalUsuario();
        },
        async setPerPage(perPage) {
            this.load(true);
            await this.setPerPagePagination(perPage);
            this.load(false);
        },
        async getUsuarioDetalle(id) {
            this.establecerAccionUsuario('Actualizar');
            await this.getUsuario(id);
            this.establecerModalUsuario();
        },
        async buscador(filtro) {
            this.users.busqueda = filtro;
            await this.getUsuarios();
        },
        async limpiar() {
            this.loading = true;
            this.users.busqueda = '';
            this.users.activo = '';
            await this.getUsuarios();
            this.loading = false;
        },
        async getUsuariosDescargable() {
            await this.exportarUsuarios(this.$route.params.id);
        },
        backRoute(){
            const currentPath = this.$route.path;
            if (currentPath.includes("/my-company")) {
                this.$router.go(-1);
            }else {
                this.$router.push("/empresas");
            }
        },
        ...mapActions('empresa', [
            'getUsuario',
            'guardaUsuario',
            'getRoles',
            'setPagePagination',
            'setPerPagePagination',
            'getUsuarios',
            'importarUsuarios',
            'listarImportesAgendados',
            'descargarPlantillaUsuarios',
            'exportarUsuarios',
            'getPermisosFiltro',
            'obtenerLicenciaActiva',
            'fetchProviders'
        ]),
        ...mapMutations('empresa', [
            'resetSelectedUsuario',
            'establecerNombreUsuario',
            'establecerModalUsuario',
            'establecerAccionUsuario',
            'setIdEmpresaSelectedUsuario',
            'resetUserFilter',
            'resetListadoUsuario',
            'setEmpUs'
        ]),
        ...mapMutations('dashboard', ['load'])
    },
};
</script>

<style>
.user-actives .el-input__inner {
  height: 35px;
}
</style>


<style scoped>

@media only screen and (max-width: 1443px) {
  .b-table-users-m {
    max-width: 908px;
  }
}
@media only screen and (max-width: 1442px) {
  .b-table-users-m {
    max-width: 906px;
  }
}

@media only screen and (max-width: 1440px) {
  .b-table-users-m {
    max-width: 904px;
  }
}

@media only screen and (max-width: 1438px) {
  .b-table-users-m {
    max-width: 902px;
  }
}

@media only screen and (max-width: 1436px) {
  .b-table-users-m {
    max-width: 900px;
  }
}

@media only screen and (max-width: 1434px) {
  .b-table-users-m {
    max-width: 899px;
  }
}

@media only screen and (max-width: 1433px) {
  .b-table-users-m {
    max-width: 898px;
  }
}

@media only screen and (max-width: 1433px) {
  .b-table-users-m {
    max-width: 100%;
  }
}


</style>


